// extracted by mini-css-extract-plugin
var _1 = "ViewMore_wrapper__bNxsj";
export { _1 as "wrapper" }
